import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function Spinner(props) {
  const { cta, downloadReportSpinner } = props;
  const isFullPage = !downloadReportSpinner;

  // Container classes
  const containerClasses = classNames({
    // Full page spinner
    'fixed top-0 left-0 right-0 bottom-0 bg-white/80 z-[10000033]': isFullPage,
    // Download report spinner
    'relative z-[10000033] h-[42px] mr-2.5 top-1.5':
      downloadReportSpinner && !cta,
    // CTA button variant
    'mx-auto w-[219px] h-[19px] top-0': downloadReportSpinner && cta,
  });

  // Spin holder classes
  const spinHoldClasses = classNames({
    'absolute top-[40%] w-full': isFullPage,
    relative: downloadReportSpinner,
  });

  // Spinner classes
  const spinnerClasses = classNames(
    'rounded-full mx-auto border-solid animate-spin',
    {
      // Full page spinner dimensions and colors
      'w-16 h-16 border-[0.7em] border-t-gray-30/87 border-r-gray-30/87 border-b-gray-30/87 border-l-teal-30':
        isFullPage,
      // Download report spinner dimensions and colors
      'w-7 h-7 border-[0.4em] border-t-gray-10/50 border-r-gray-10/50 border-b-gray-10/50 border-l-teal-30':
        downloadReportSpinner,
    },
  );

  return (
    <div className={containerClasses}>
      <div className={spinHoldClasses}>
        <div className={spinnerClasses} />
      </div>
    </div>
  );
}

Spinner.propTypes = {
  cta: PropTypes.bool,
};

export default Spinner;
